import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
export function createLazyIcon(importer) {
    const Icon = lazy(importer);
    function LazyIcon() {
        return _jsx(Suspense, Object.assign({ fallback: null }, { children: _jsx(Icon, {}) }));
    }
    return LazyIcon;
}
//# sourceMappingURL=createLazyIcon.js.map